import React from 'react'
import style from './style.less'
import classNames from 'classnames'
import Typography, {
  TypographySizes,
  TypographyTypes,
} from '../Typography/Typography'

export interface ButtonProps {
  className?: string
  disabled?: boolean
  onClick: (event: React.MouseEvent<HTMLElement>) => void
  text?: string | React.ReactNode
  title?: string
  icon?: React.ReactNode
  secondary?: boolean
  tertiary?: boolean
  newButton?: boolean
  fullWidth?: boolean
}

const Button: React.FunctionComponent<ButtonProps> = ({
  className,
  text,
  title,
  onClick,
  disabled = false,
  icon,
  secondary = false,
  tertiary = false,
  fullWidth = false,
  newButton = false,
}) => (
  <button
    disabled={disabled}
    className={classNames(
      className,
      !newButton ? style.button : undefined,
      secondary ? style.secondary : undefined,
      tertiary ? style.tertiary : undefined,
      fullWidth ? style.fullWidth : undefined,
      newButton ? style.newButton : undefined
    )}
    title={title}
    onClick={onClick}
  >
    <>
      {icon}
      {text && (
        <Typography type={TypographyTypes.label} size={TypographySizes.large}>
          {text}
        </Typography>
      )}
    </>
  </button>
)

export default Button
